import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  useMediaQuery
} from '@mui/material';
import { ArrowForward, ArrowBack } from '@mui/icons-material';
import { motion } from 'framer-motion';

import signalsLogo from '../../assets/icons/signals-logo-blue.svg';
import loginBackground from '../assets/images/login-background.jpg';

import { AUTH_COLORS, AUTH_BREAKPOINTS } from './shared/authConstants';

const AuthChoiceScreen = ({ onChoiceSelect }) => {
  const isMobile = useMediaQuery(AUTH_BREAKPOINTS.mobile);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${loginBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: isMobile ? 'scroll' : 'fixed',
        position: 'relative'
      }}
    >
      <Box sx={{ position: 'absolute', top: 20, left: 20, zIndex: 3 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => (window.location.href = '/')}
          sx={{
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              borderColor: 'rgba(255, 255, 255, 0.3)'
            },
            fontWeight: 500,
            textTransform: 'none',
            borderRadius: 2,
            px: 2.5,
            py: 1
          }}
        >
          Back to main page
        </Button>{' '}
      </Box>

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth: '500px',
          padding: isMobile ? '20px 16px' : '0 24px',
          minHeight: isMobile ? '100vh' : 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
            mb: 4
          }}
        >
          <Typography
            variant={isMobile ? 'h4' : 'h3'}
            sx={{
              fontFamily: 'Nunito Sans, sans-serif',
              fontWeight: 700,
              color: 'white',
              textShadow: '0 2px 10px rgba(0,0,0,0.3)'
            }}
          >
            Welcome
          </Typography>
        </Box>
        <Grid container justifyContent='center'>
          <Grid item xs={12}>
            <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
              <Card
                sx={{
                  height: { xs: 'auto', sm: '280px' },
                  cursor: 'pointer',
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.2)'
                  }
                }}
                onClick={() => onChoiceSelect('signals')}
              >
                <CardContent
                  sx={{
                    p: { xs: 3, sm: 4 },
                    textAlign: 'center',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}
                >
                  <Box>
                    <img
                      src={signalsLogo}
                      alt='Signals Logo'
                      style={{
                        height: isMobile ? '70px' : '85px',
                        width: 'auto',
                        marginBottom: '16px'
                      }}
                    />
                    <Typography
                      variant='body1'
                      sx={{
                        color: '#636363',
                        lineHeight: 1.6,
                        fontSize: { xs: '1rem', sm: '1.1rem' },
                        mb: 2
                      }}
                    >
                      See our Strategies in Real Time
                    </Typography>
                  </Box>
                  <Box sx={{ mt: 'auto' }}>
                    <Button
                      variant='contained'
                      endIcon={<ArrowForward />}
                      fullWidth
                      sx={{
                        backgroundColor: AUTH_COLORS.SIGNAL_PURPLE,
                        '&:hover': {
                          backgroundColor: AUTH_COLORS.SIGNAL_PURPLE_HOVER
                        },
                        py: { xs: 1.2, sm: 1.5 },
                        fontSize: { xs: '0.95rem', sm: '1rem' },
                        fontWeight: 600
                      }}
                    >
                      Get Started
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        </Grid>
      </motion.div>
    </Box>
  );
};

export default AuthChoiceScreen;
